module.exports = __webpack_public_path__ + "img/gift_thermos.64581a2b.png";